module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.someProgramIsOffered) ? _c('CollectionQuestion', {
    key: _vm.childKey,
    ref: "child",
    attrs: {
      "question": _vm.questionWithFilteredProgramOptions,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d78fb2b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/FinanceIndicatorsQuestion.vue
// module id = 773
// module chunks = 1